import React from 'react';
import { withRouter } from 'react-router-dom';
import RentDetails from './rent-details';
import AgreementPreview from './agreement-preview';
import RentAgreementStepper from '../rent-agreement-stepper/index'

class RentAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: {},
    }
  }

  updateVal = (event) => {
    let values = this.state.values;
    values[event.target.id] = event.target.value;
    this.setState({ values });
  }

  updateDate = (value, id) => {
    let values = this.state.values;
    values[id] = value.toLocaleDateString()
    this.setState({ values });
  }

  updateLocation = (item) => {
    if (typeof item.name !== 'undefined') {
      this.setState({
        selectedLocation: item
      });
    }
  }

  render() {
    return (
      <section className="section">
        <div className="container">
          <RentAgreementStepper />
          <div className="columns">
            <div className="column is-6">
              <AgreementPreview selectedLocation={this.state.selectedLocation} />
            </div>
            <div className="column is-6">
              <div className="rent-agreement-form">
                <h2 className="is-size-4 level" style={{ marginBottom: "1rem" }}>
                  <span className="level-left">
                    <span className="level-item">Online Rent Agreement&nbsp;</span>
                  </span>
                  <span className="level-right">
                    {this.state.selectedLocation.name ?
                      <span className="level-item">({this.state.selectedLocation.name})</span> : null}
                  </span>
                </h2>
                <div>
                  <RentDetails
                    onChangeLocation={this.updateLocation}
                  // selectedLocation={this.state.selectedLocation}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(RentAgreement);


// WEBPACK FOOTER //
// ./src/app/components/rent-agreement/index.js